// src/pages/churches/churchService.js
import axios from "../../services/axiosConfig";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import { getAuthToken } from "../../auth/auth";

export const getChurches = async () => {
  try {
    const token = await getAuthToken();
    const res = await axios.get(API_ENDPOINTS.CHURCHES, {
      headers: { Authorization: `Bearer ${token}` }
    });

    console.log("[getChurches] Raw axios response:", res);
    // 🔥 YOUR CASE: API returns array directly
    if (Array.isArray(res.data)) {
      return res.data;
    }
    // API Gateway-style response
    if (res?.data?.body) {
      const parsed = JSON.parse(res.data.body);
      return parsed.churches || parsed.items || [];
    }

    // Normal JSON response
    return res?.data?.churches || res?.data?.items || [];
  } catch (error) {
    console.error("[getChurches] API failed:", error);
    return []; // 🔥 CRITICAL: never return undefined
  }
};

export const getChurchById = async (id) => {
  const token = await getAuthToken();
  const res = await axios.get(`${API_ENDPOINTS.CHURCHES}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};

export const createChurch = async (data) => {
  const token = await getAuthToken();
  await axios.post(API_ENDPOINTS.CHURCHES, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateChurch = async (id, data) => {
  const token = await getAuthToken();
  await axios.put(`${API_ENDPOINTS.CHURCHES}/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const deleteChurch = async (id) => {
  const token = await getAuthToken();
  await axios.delete(`${API_ENDPOINTS.CHURCHES}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const provisionChurch = async (churchId) => {
  const token = await getAuthToken();
  await axios.patch(
    `${API_ENDPOINTS.CHURCHES}/${churchId}/provision`,
    null, //no body
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};
